import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import Tick from '@img/icons/tick-red.svg?url';
import styled, { css } from 'styled-components';
import { CheckboxTheme } from './Checkbox';

export const CheckboxLabel = styled.label<{ theme?: CheckboxTheme }>`
  display: block;
  ${fonts.helvetica['53-extended']};
  line-height: 18px;
  margin-bottom: 10px;
  font-size: 12px;
  letter-spacing: normal;
  text-transform: none;
  user-select: none;

  ${({ theme }) => {
    switch (theme) {
      default:
      case CheckboxTheme.White: {
        return css`
          color: ${brand.white};
        `;
      }

      case CheckboxTheme.Black: {
        return css`
          color: ${brand.black};
        `;
      }
    }
  }};

  a {
    color: inherit;
    ${fonts.helvetica['93-black-extended']};
  }
`;

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })<{ theme?: CheckboxTheme }>`
  display: none;

  + ${CheckboxLabel} {
    cursor: pointer;
    position: relative;
    padding-left: 34px;
    font-size: 12px;
    line-height: 20px;
    ${fonts.helvetica['53-extended']};
    z-index: 1;

    // legacy fix
    float: none !important;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 18px;
      height: 18px;
      z-index: 1;
      background-color: transparent;
      border: 2px solid transparent;
    }

    &::before {
      border-radius: 2px;
      transition: background-color 0.3s ease;
    }

    &::after {
      background-size: 12px;
      background-image: url(${Tick});
      background-repeat: no-repeat;
      background-position: center;
      transform: translateY(-8px) scale(0);
      transition: transform 0.3s ease;
    }

    ${({ theme }) => {
      switch (theme) {
        case CheckboxTheme.Black:
          return css`
            color: ${brand.black};

            &::before {
              border-color: ${brand.grey[25]};
            }
          `;

        case CheckboxTheme.White:
        default:
          return css`
            color: ${brand.white};

            &::before {
              border-color: ${brand.white};
            }
          `;
      }
    }};

    span {
      // legacy fix
      display: none !important;
    }
  }

  &:checked + ${CheckboxLabel} {
    &::before {
      background-color: ${brand.white};
    }

    &::after {
      transform: translateY(0px) scale(1);
    }
  }

  &:disabled + ${CheckboxLabel} {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
